import { FadeIn, MaskedLineScroll, Overline } from "@/components/Reveal";

const PHOTOS = [
  {
    src: "/photos/equipe.webp",
    alt: "Couvreur MSC Toitures en intervention sur un échafaudage dans le Val-de-Marne",
    caption: "Intervention en hauteur — Val-de-Marne",
    cls: "md:col-span-7",
  },
  {
    src: "/photos/chantier.webp",
    alt: "Chantier de couverture MSC Toitures avec échafaudage et bâche de chantier",
    caption: "Chantier de couverture — échafaudage",
    cls: "md:col-span-5",
  },
  {
    src: "/photos/refection-saint-maur.webp",
    alt: "Réfection de toiture en tuiles par MSC Toitures à Saint-Maur-des-Fossés",
    caption: "Réfection de toiture — Saint-Maur-des-Fossés",
    cls: "md:col-span-5",
  },
  {
    src: "/photos/refection-pendant.webp",
    alt: "Réfection de toiture en cours : liteaux et écran de sous-toiture posés par MSC Toitures",
    caption: "Réfection en cours — liteaux & sous-toiture",
    cls: "md:col-span-7",
  },
  {
    src: "/photos/zinguerie-avant.webp",
    alt: "Toiture en zinc avant intervention de MSC Toitures dans le Val-de-Marne",
    caption: "Zinguerie — avant",
    cls: "md:col-span-5",
  },
  {
    src: "/photos/zinguerie-apres.webp",
    alt: "Toiture en zinc après travaux de zinguerie par MSC Toitures",
    caption: "Zinguerie — après",
    cls: "md:col-span-7",
  },
  {
    src: "/photos/refection-termine.webp",
    alt: "Toiture en tuiles terminée avec velux après réfection par MSC Toitures",
    caption: "Réfection terminée — tuiles & velux",
    cls: "md:col-span-7",
  },
  {
    src: "/showroom.webp",
    alt: "Devanture du showroom MSC Toitures, 34 boulevard de Polangis à Champigny-sur-Marne",
    caption: "Le showroom — Champigny-sur-Marne",
    cls: "md:col-span-5",
  },
  {
    src: "/photos/toiture-bac-acier-joinville-le-pont.webp",
    alt: "Toiture en bac acier réalisée par MSC Toitures à Joinville-le-Pont",
    caption: "Toiture bac acier — Joinville-le-Pont",
    cls: "md:col-span-7",
  },
  {
    src: "/photos/zinc-joint-debout-saint-maur-des-fosses.webp",
    alt: "Toiture en zinc joint debout posée par MSC Toitures à Saint-Maur-des-Fossés",
    caption: "Zinc joint debout — Saint-Maur-des-Fossés",
    cls: "md:col-span-5",
  },
  {
    src: "/photos/toiture-zinc-94.webp",
    alt: "Toiture en zinc en cours de pose par MSC Toitures dans le Val-de-Marne",
    caption: "Toiture en zinc — Val-de-Marne",
    cls: "md:col-span-7",
  },
  {
    src: "/photos/reparation-toiture-94.webp",
    alt: "Réparation de toiture en zinc avec souche de cheminée par MSC Toitures dans le 94",
    caption: "Réparation de toiture — 94",
    cls: "md:col-span-5",
  },
  {
    src: "/photos/refection-toiture-94.webp",
    alt: "Réfection de toiture par MSC Toitures : couvreur devant le chantier avec échafaudage",
    caption: "Réfection de toiture — 94",
    cls: "md:col-span-7",
  },
  {
    src: "/photos/refection.webp",
    alt: "Chantier MSC Toitures avec échafaudage et bâche publicitaire dans le Val-de-Marne",
    caption: "Chantier en cours — bâche MSC Toitures",
    cls: "md:col-span-5",
  },
];

export default function Gallery() {
  return (
    <section className="bg-white py-24 md:py-32 border-b border-midnight/10" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-6">
            <Overline>Nos réalisations</Overline>
            <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-4xl lg:text-5xl">
              <MaskedLineScroll>Nos réalisations dans le</MaskedLineScroll>
              <MaskedLineScroll delay={0.12}><span className="text-signal">Val-de-Marne</span></MaskedLineScroll>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <FadeIn delay={0.2}>
              <p className="text-base md:text-lg text-midnight/70 leading-relaxed">
                Échafaudages, couvertures, interventions sur pavillons : un aperçu de nos chantiers
                dans le département. Chaque projet commence par un déplacement et un devis gratuits.
              </p>
            </FadeIn>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
          {PHOTOS.map((p, i) => (
            <FadeIn key={p.src} delay={i * 0.1} className={p.cls}>
              <figure className="group relative h-full overflow-hidden border border-midnight/10 aspect-[4/3] md:aspect-auto md:h-[380px] lg:h-[440px]" data-testid={`gallery-item-${i}`}>
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
                />
                <figcaption className="absolute bottom-0 left-0 right-0 flex items-center justify-between gap-4 bg-midnight/85 backdrop-blur-sm px-5 py-3">
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/80">{p.caption}</span>
                  <span className="font-mono text-[10px] text-signal">{String(i + 1).padStart(2, "0")}</span>
                </figcaption>
              </figure>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
